import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../../Accordion/Accordion.js";
import data1 from "../../../Data/regulatoryDocuments/regulatoryDocumentsDataDoc.json";
import data2 from "../../../Data/regulatoryDocuments/regulatoryDocumentsDataStandart.json";
import data3 from "../../../Data/regulatoryDocuments/regulatoryDocumentsDataLocal.json";

export default function RegulatoryDocuments() {
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Нормативные документы
      </h1>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Перечень законодательных и нормативно - правовых документов
        </h3>

        <Accordion data={data1} />
      </div>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Образовательные стандарты
        </h3>

        <Accordion data={data2} />
      </div>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Локальные нормативные акты по основным вопросам организации и
          осуществления образовательной деятельности
        </h3>

        <Accordion data={data3} />
      </div>
    </section>
  );
}
